// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Gameover_wrapper__2NbZt","header":"Gameover_header__iVG6O","hidden":"Gameover_hidden__1xXB5"};